var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ModuleCourse" },
    [
      _vm.bol1
        ? _c("Id1", { attrs: { data: _vm.data } })
        : _vm.bol2
        ? _c("Id2", { attrs: { data: _vm.data } })
        : _vm.bol3
        ? _c("Id3", {
            ref: "AAA",
            attrs: {
              data: _vm.data,
              curriculaId: _vm.curriculaId,
              isLast: _vm.lastId3
            },
            on: {
              collectAnswers: _vm.pushAnswers,
              toAnwers: _vm.toAnwers,
              toModify: _vm.toModify,
              needModify: _vm.needModify
            }
          })
        : _vm.bol4
        ? _c("Id4", { attrs: { data: _vm.data } })
        : _vm.bol5
        ? _c("Id5", { attrs: { data: _vm.data } })
        : _vm.bol6
        ? _c("Id6", { attrs: { data: _vm.data } })
        : _vm.bol7
        ? _c("Id7", { attrs: { data: _vm.data } })
        : _vm.bol8
        ? _c("Id8", { attrs: { data: _vm.data } })
        : _vm.bol9
        ? _c("Id9", { attrs: { data: _vm.data } })
        : _vm.bol10
        ? _c("Id10", { attrs: { data: _vm.data } })
        : _vm.bol15
        ? _c("Id15", { attrs: { data: _vm.data } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-16a6511a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-16a6511a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/main.vue
// module id = null
// module chunks = 